import React from "react";

/**
 * Componente SummaryCards para mostrar resumen de finanzas del mes
 * 
 * @param {Object} props
 * @param {Object} props.summary - Objeto con { income, totalCommitted, totalPaid, totalPending, availableRemaining }
 * @param {Function} props.formatAmount - Función para formatear montos
 */
const SummaryCards = ({ summary, formatAmount }) => {
  const cards = [
    {
      label: "Ingresos del Mes",
      amount: summary.income,
      gradient: "from-green-500 to-green-600",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      label: "Total Comprometido",
      amount: summary.totalCommitted,
      gradient: "from-orange-500 to-red-500",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      ),
      subtitle: `Pagado: ${formatAmount(summary.totalPaid)} | Pendiente: ${formatAmount(summary.totalPending)}`
    },
    {
      label: "Pagado Hasta Hoy",
      amount: summary.totalPaid,
      gradient: "from-blue-500 to-indigo-600",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      subtitle: `Gastos reales descontados`
    },
    {
      label: "Restante Disponible",
      amount: summary.availableRemaining,
      gradient: summary.availableRemaining >= 0 ? "from-emerald-500 to-teal-600" : "from-red-600 to-red-700",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
      subtitle: `Dinero real disponible`
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`bg-gradient-to-br ${card.gradient} rounded-xl p-4 text-white shadow-md`}
        >
          <div className="flex items-center gap-2 mb-2">
            <div className="opacity-80 scale-90">{card.icon}</div>
            <p className="text-xs font-medium opacity-90">{card.label}</p>
          </div>
          <p className="text-2xl font-bold mb-1">
            {formatAmount(card.amount)}
          </p>
          {card.subtitle && (
            <p className="text-xs opacity-75">{card.subtitle}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
